/* prettier-ignore-start */

/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file is auto-generated by TanStack Router

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as SpringHealthImport } from './routes/spring-health'
import { Route as LoginImport } from './routes/login'
import { Route as GsAdminImport } from './routes/gs-admin'
import { Route as SpringHealthVerifyImport } from './routes/spring-health/verify'
import { Route as SpringHealthRegisterImport } from './routes/spring-health/register'
import { Route as MembersSplatImport } from './routes/members.$'
import { Route as GsAdminMembersImport } from './routes/gs-admin/members'
import { Route as GsAdminMembersIndexImport } from './routes/gs-admin/members.index'
import { Route as GsAdminMembersSearchImport } from './routes/gs-admin/members.search'
import { Route as GsAdminMembersEnrollImport } from './routes/gs-admin/members.enroll'

// Create/Update Routes

const SpringHealthRoute = SpringHealthImport.update({
  path: '/spring-health',
  getParentRoute: () => rootRoute,
} as any)

const LoginRoute = LoginImport.update({
  path: '/login',
  getParentRoute: () => rootRoute,
} as any)

const GsAdminRoute = GsAdminImport.update({
  path: '/gs-admin',
  getParentRoute: () => rootRoute,
} as any)

const SpringHealthVerifyRoute = SpringHealthVerifyImport.update({
  path: '/verify',
  getParentRoute: () => SpringHealthRoute,
} as any)

const SpringHealthRegisterRoute = SpringHealthRegisterImport.update({
  path: '/register',
  getParentRoute: () => SpringHealthRoute,
} as any)

const MembersSplatRoute = MembersSplatImport.update({
  path: '/members/$',
  getParentRoute: () => rootRoute,
} as any)

const GsAdminMembersRoute = GsAdminMembersImport.update({
  path: '/members',
  getParentRoute: () => GsAdminRoute,
} as any)

const GsAdminMembersIndexRoute = GsAdminMembersIndexImport.update({
  path: '/',
  getParentRoute: () => GsAdminMembersRoute,
} as any)

const GsAdminMembersSearchRoute = GsAdminMembersSearchImport.update({
  path: '/search',
  getParentRoute: () => GsAdminMembersRoute,
} as any)

const GsAdminMembersEnrollRoute = GsAdminMembersEnrollImport.update({
  path: '/enroll',
  getParentRoute: () => GsAdminMembersRoute,
} as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/gs-admin': {
      id: '/gs-admin'
      path: '/gs-admin'
      fullPath: '/gs-admin'
      preLoaderRoute: typeof GsAdminImport
      parentRoute: typeof rootRoute
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginImport
      parentRoute: typeof rootRoute
    }
    '/spring-health': {
      id: '/spring-health'
      path: '/spring-health'
      fullPath: '/spring-health'
      preLoaderRoute: typeof SpringHealthImport
      parentRoute: typeof rootRoute
    }
    '/gs-admin/members': {
      id: '/gs-admin/members'
      path: '/members'
      fullPath: '/gs-admin/members'
      preLoaderRoute: typeof GsAdminMembersImport
      parentRoute: typeof GsAdminImport
    }
    '/members/$': {
      id: '/members/$'
      path: '/members/$'
      fullPath: '/members/$'
      preLoaderRoute: typeof MembersSplatImport
      parentRoute: typeof rootRoute
    }
    '/spring-health/register': {
      id: '/spring-health/register'
      path: '/register'
      fullPath: '/spring-health/register'
      preLoaderRoute: typeof SpringHealthRegisterImport
      parentRoute: typeof SpringHealthImport
    }
    '/spring-health/verify': {
      id: '/spring-health/verify'
      path: '/verify'
      fullPath: '/spring-health/verify'
      preLoaderRoute: typeof SpringHealthVerifyImport
      parentRoute: typeof SpringHealthImport
    }
    '/gs-admin/members/enroll': {
      id: '/gs-admin/members/enroll'
      path: '/enroll'
      fullPath: '/gs-admin/members/enroll'
      preLoaderRoute: typeof GsAdminMembersEnrollImport
      parentRoute: typeof GsAdminMembersImport
    }
    '/gs-admin/members/search': {
      id: '/gs-admin/members/search'
      path: '/search'
      fullPath: '/gs-admin/members/search'
      preLoaderRoute: typeof GsAdminMembersSearchImport
      parentRoute: typeof GsAdminMembersImport
    }
    '/gs-admin/members/': {
      id: '/gs-admin/members/'
      path: '/'
      fullPath: '/gs-admin/members/'
      preLoaderRoute: typeof GsAdminMembersIndexImport
      parentRoute: typeof GsAdminMembersImport
    }
  }
}

// Create and export the route tree

export const routeTree = rootRoute.addChildren({
  GsAdminRoute: GsAdminRoute.addChildren({
    GsAdminMembersRoute: GsAdminMembersRoute.addChildren({
      GsAdminMembersEnrollRoute,
      GsAdminMembersSearchRoute,
      GsAdminMembersIndexRoute,
    }),
  }),
  LoginRoute,
  SpringHealthRoute: SpringHealthRoute.addChildren({
    SpringHealthRegisterRoute,
    SpringHealthVerifyRoute,
  }),
  MembersSplatRoute,
})

/* prettier-ignore-end */

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/gs-admin",
        "/login",
        "/spring-health",
        "/members/$"
      ]
    },
    "/gs-admin": {
      "filePath": "gs-admin.tsx",
      "children": [
        "/gs-admin/members"
      ]
    },
    "/login": {
      "filePath": "login.tsx"
    },
    "/spring-health": {
      "filePath": "spring-health.tsx",
      "children": [
        "/spring-health/register",
        "/spring-health/verify"
      ]
    },
    "/gs-admin/members": {
      "filePath": "gs-admin/members.tsx",
      "parent": "/gs-admin",
      "children": [
        "/gs-admin/members/enroll",
        "/gs-admin/members/search",
        "/gs-admin/members/"
      ]
    },
    "/members/$": {
      "filePath": "members.$.tsx"
    },
    "/spring-health/register": {
      "filePath": "spring-health/register.tsx",
      "parent": "/spring-health"
    },
    "/spring-health/verify": {
      "filePath": "spring-health/verify.tsx",
      "parent": "/spring-health"
    },
    "/gs-admin/members/enroll": {
      "filePath": "gs-admin/members.enroll.tsx",
      "parent": "/gs-admin/members"
    },
    "/gs-admin/members/search": {
      "filePath": "gs-admin/members.search.tsx",
      "parent": "/gs-admin/members"
    },
    "/gs-admin/members/": {
      "filePath": "gs-admin/members.index.tsx",
      "parent": "/gs-admin/members"
    }
  }
}
ROUTE_MANIFEST_END */
